import { axiosClient } from "@/shared/api/axios-client";
import type {
  Area,
  CentroDeCosto,
  ClaveSat,
  CuentaContable,
  IndicadorImpuesto,
  TipoDocumentoAdicional,
} from "@/lib/types";

/**
 * Capa pura sobre los endpoints de catálogos de la API. Cada función es
 * idempotente y devuelve una Promise · sin hooks, sin React.
 */
export const catalogosApi = {
  listarAreas: () =>
    axiosClient.get<Area[]>("/api/catalogos/areas").then((r) => r.data),

  listarCentrosDeCosto: () =>
    axiosClient
      .get<CentroDeCosto[]>("/api/catalogos/centros-de-costo")
      .then((r) => r.data),

  listarCuentasContables: () =>
    axiosClient
      .get<CuentaContable[]>("/api/catalogos/cuentas-contables")
      .then((r) => r.data),

  listarClavesSat: () =>
    axiosClient
      .get<ClaveSat[]>("/api/catalogos/claves-sat")
      .then((r) => r.data),

  listarTiposDocumento: () =>
    axiosClient
      .get<TipoDocumentoAdicional[]>("/api/catalogos/tipos-documento")
      .then((r) => r.data),

  listarIndicadoresImpuesto: () =>
    axiosClient
      .get<IndicadorImpuesto[]>("/api/catalogos/indicadores-impuesto")
      .then((r) => r.data),
};
